import React from 'react'
import { BulletList } from './BulletList.jsx'

export function NumberedBulletList(props) {
  return <BulletList {...props} numbered maxItems={props.maxItems ?? 3} />
}
